export enum SSENotificationTypes {
  ORDERS_CREATE = 'orders.create',
  ORDERS_EDIT = 'orders.edit',
  PRICES_CREATE = 'prices.create',
  PRICES_EDIT = 'prices.edit',
  PRICES_DELETE = 'prices.delete',
  EXCHANGES_CREATE = 'exchanges.create',
  EXCHANGES_EDIT = 'exchanges.edit',
  EXCHANGES_DELETE = 'exchanges.delete'
}